<template>
	<div id="chatviewContainer" >
		<div id="chatview" draggable="true">
			<div id="messagesContainer">
				<ul id="messages"></ul>
			</div>
			<div id="inputContainer">
			    <form action="" v-on:submit="submitMessage">
					<div id="textareaContainer">
				    	<textarea v-on:keyup="inputKeyPress" v-on:focus="setWritingTrue" v-on:blur="setWritingFalse" id="m" resizable="false" autocomplete="off"></textarea>
					</div>
			    </form>
				<button v-on:click="submitMessage"><i class="fa fa-paper-plane" aria-hidden="true"></i></button>
			</div>
		</div>
	</div>
</template>

<script> 
//import {SocketInstance} from 'vue';
export default {
  name: 'chatview',
  //props: ['nwmsg'],	    
  data() {
	  return {
	      writing: false
	      }
	   },
  methods: {
	  
	  setWritingTrue(){ this.writing = true; },
	  setWritingFalse(){ this.writing = false; },
	  
	  
	  inputKeyPress(e){
		  
		  if(this.writing === false) return;
/*
		  { 
			  if(e.keyCode == 27) { this.$emit('close-chat',''); console.log('close chat'); } 
			  else return ;
			  } 
*/
		  
		  //console.log(e);
		  if(e.keyCode == 13 && e.shiftKey !== true) this.submitMessage(e);
		  if(e.keyCode == 27) e.currentTarget.blur();
		  
		  this.adjustHeight(e);
	  },

	  adjustHeight: function(e){
        var t = e.currentTarget;
        t.style.height = '18px';
        t.style.height = Math.max(t.scrollHeight, t.offsetHeight) + 'px';
	  },
	  submitMessage: function(e){
		  e.preventDefault();
		  var newmsg = $('#m').val();
		  //console.log(newmsg);
		  if(newmsg !="") {
	      	this.$socket.emit('chatMessage', newmsg);
		  	$('#messages').append($('<li class="myself">').html( "<span class='message'>"+ newmsg.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + "<br>" + '$2') +"</span" ));
		  	$('#messages').animate({ scrollTo: $('li:last','#messages') });		  	
		  	$('#m').val('').css({ height: '18px' });
		  }
	      return false;
	  }
  },
  sockets: {
    chatMessage(msg) {
	    console.log(msg);
      $('#messages').append($('<li>').html("<span class='message'>"+msg+"</span"));
    },
    chat_message(msg) {
	    console.log(msg);
      $('#messages').append($('<li>').html("<span class='message'>"+msg+"</span"));
    },	  
    chatmessage(msg) {
	    console.log(msg);
      $('#messages').append($('<li>').html("<span class='message'>"+msg+"</span"));
    }	

	  
  }
  
}

</script>

<style>
	#chatviewContainer { position: fixed; z-index: 10002; background: rgba(0,0,0,0.6); top: 66px; bottom: 0; left: 0; right: 0; }	
	#chatview { position: absolute; top: 0px; left: 50%; width: 100%; max-width: 30em; bottom: 50px; border: 1px solid rgb(64,155,233); border-radius: 0 0 8px 8px; background: rgb(64,155,233); transform: translate(-50%,0);
		display: flex; 
		flex-direction: column;		
	}

	#messagesContainer { align-self: stretch; flex-grow: 1; overflow: scroll; width: 100%;  -webkit-overflow-scrolling: touch; }
	#messagesContainer { padding: 0.933333333em; }
	#messagesContainer li { clear:both; float: left; padding: 0.4444444em 0; position: relative; max-width: 80%; }
	#messagesContainer li.myself { clear:both; float: right; }	

	#messagesContainer li .message { display: block; background: #fff; padding: 0.43333333em 0.9333333em; text-align: left;  
/*
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
*/		
		  overflow-wrap: break-word;
		  word-wrap: break-word;		
		  -ms-word-break: break-all;
		  word-break: break-all;
		  word-break: break-word;
		  -ms-hyphens: auto;
		  -moz-hyphens: auto;
		  -webkit-hyphens: auto;
		  hyphens: auto;

	}
	
	#messagesContainer li.myself .message { background: #adeaf5; 

  /*
		  overflow-wrap: break-word;
		  word-wrap: break-word;		
		  -ms-word-break: break-all;
		  word-break: break-all;
		  word-break: break-word;
		  -ms-hyphens: auto;
		  -moz-hyphens: auto;
		  -webkit-hyphens: auto;
		  hyphens: auto;
*/		
	}
	#messagesContainer li .message:after { content: " "; position: absolute; top: 12px; left: -8px; border-top: 0 solid transparent; border-bottom: 12px solid transparent; border-right: 12px solid #fff; border-left: 0;   }
	#messagesContainer li.myself .message:after { content: " "; position: absolute; top: 12px; left: auto; right: -8px; border-top: 0 solid transparent; border-bottom: 12px solid transparent; border-left: 12px solid #adeaf5; border-right: 0;   }


	#inputContainer { border-top: 1px solid #fff; padding: 0.93333333em; width: 100%; align-self: flex-end; position: relative; }
	#inputContainer #textareaContainer { border-radius: 5px; border: 0; background: #fff; padding: 0.733333333em 0.933333333em; margin-right: 3em; position: relative; } 
	#inputContainer textarea { resize: none; display: block; width: 100%; height: 18px; font-size: 1em; border: 0; overflow: hidden; }
	#inputContainer textarea:focus { outline: 0; }
	#inputContainer button { background: transparent; padding: 0; margin: 0; border: 0; position: absolute; top: 1.933333333em; right: 1.933333333em; }
	#inputContainer button .fa { color: #fff; font-size: 2.2em; }
</style>


